import { EvaluationDecision } from "../types";

/**
 * Props for the decision badge shown on the Summary tab.
 */
interface DecisionBadgeProps {
  /** Raw decision from the evaluation engine (e.g. APPROVE). */
  decision: EvaluationDecision;
}

/**
 * Maps an evaluation decision to display label and badge styles.
 *
 * @param decision - Evaluation engine decision
 * @returns Label and Tailwind class pair for the badge
 */
const getDecisionStyles = (
  decision: EvaluationDecision,
): { label: string; className: string } => {
  switch (decision) {
    case "APPROVE":
      return {
        label: "Approve",
        className: "bg-tertiaryGreen-50 text-tertiaryGreen-700",
      };
    case "DENY":
      return {
        label: "Deny",
        className: "bg-tertiaryRed-50 text-tertiaryRed-600",
      };
    case "PEND":
      return {
        label: "Pend",
        className: "bg-secondaryYellow-11 text-secondaryYellow-2",
      };
    case "ESCALATE":
    default:
      return {
        label: "Escalate",
        className: "bg-secondaryYellow-11 text-secondaryYellow-2",
      };
  }
};

/**
 * Pill badge for the evaluation decision (Approve / Deny / Escalate).
 *
 * @param props.decision - Evaluation engine decision value
 */
const DecisionBadge = (props: DecisionBadgeProps) => {
  const styles = getDecisionStyles(props.decision);

  return (
    <span
      className={`inline-flex w-fit items-center rounded px-2 py-0.5 text-x-tiny font-semibold ${styles.className}`}
    >
      {styles.label}
    </span>
  );
};

export default DecisionBadge;
